import React, { useEffect } from 'react';
import { BasePage } from 'altus-ui-components';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import { getIntegrityManagementWellIntegrityHistoryFromState } from 'features/settings/integrityManagement/helpers/integrityManagement.selectors';
import { INTEGRITY_MANAGEMENT_ACTIONS } from 'features/settings/integrityManagement/helpers/integrityManagement.constants';
import { getSummarizedDataStateFromState } from 'app/app.selectors';
import { loadIntegrityManagementWellIntegrityHistory } from 'features/settings/integrityManagement/helpers/integrityManagement.actions';
import useWellbore from 'features/wells/hooks/useWellbore';
import IntegrityDetailsHistoryTable from 'features/wells/integrity/integrityDetails/history/IntegrityDetailsHistoryTable';

const IntegrityDetailsHistoryContainer = ({
  classes,
  wellboreId,
  integrityId,
  history,
  dispatchLoadWellIntegrityHistory,
}) => {
  const { wellbore } = useWellbore(wellboreId);

  useEffect(() => {
    if (wellbore.get('externalWellboreExternalId') && integrityId)
      dispatchLoadWellIntegrityHistory(
        wellbore.get('externalWellboreExternalId'),
        integrityId,
      );
  }, [wellbore, integrityId, dispatchLoadWellIntegrityHistory]);

  return (
    <BasePage>
      {history && (
        <Grid container className={classes.historyTable}>
          <Grid item xs={10}>
            <IntegrityDetailsHistoryTable history={history} />
          </Grid>
        </Grid>
      )}
    </BasePage>
  );
};

const styles = (theme) => ({
  historyTable: {
    paddingTop: theme.spacing(2),
  },
});

export default compose(
  connect(
    (state) => ({
      dataState: getSummarizedDataStateFromState(
        state,
        INTEGRITY_MANAGEMENT_ACTIONS.GET_INTEGRITY_MANAGEMENT_WELL_INTEGRITY_HISTORY,
      ),
      history: getIntegrityManagementWellIntegrityHistoryFromState(
        state,
        INTEGRITY_MANAGEMENT_ACTIONS.GET_INTEGRITY_MANAGEMENT_WELL_INTEGRITY_HISTORY,
      ),
    }),
    {
      dispatchLoadWellIntegrityHistory:
        loadIntegrityManagementWellIntegrityHistory,
    },
  ),
  withStyles(styles),
)(IntegrityDetailsHistoryContainer);
